import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from '../components/layout/Header';
import Footer from '../components/layout/Footer';
import { API_URL } from '../config/api';

const SourcesPage = () => {
  const [sources, setSources] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API_URL}/v1/sources`)
      .then(res => setSources(res.data))
      .catch(err => console.error('Failed to load sources', err))
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Header />
      <main className="main page-content">
        <h1 className="page-title">Our Sources</h1>
        <p className="page-subtitle">
          We track {sources?.total || 20} news sources across 5 global regions. 
          Each source is labeled with its editorial positioning for transparency.
        </p>
        
        {loading ? (
          <div className="loading"><p>Loading sources...</p></div>
        ) : sources?.by_region ? (
          <div className="sources-grid">
            {sources.by_region.map(region => (
              <div key={region.region} className="source-region-card">
                <h2 className="region-title">{region.label}</h2>
                <div className="region-sources">
                  {region.sources.map(source => (
                    <div key={source.id} className="source-card">
                      <h3>{source.name}</h3>
                      <p className="positioning">{source.positioning}</p>
                      <a href={source.homepage} target="_blank" rel="noopener noreferrer">
                        Visit →
                      </a>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="empty-state"><p>No sources available</p></div>
        )}
      </main>
      <Footer />
    </>
  );
};

export default SourcesPage;
